import React from 'react';
import IconName from "../../svgLogo/SvgLogo";
import GalleryImage from "./gallery/GalleryImage";
import GalleryImageResponsive from "./gallery/GalleryImageResponsive";
import {Link} from "react-router-dom";

const TopGalleryProduct = () => {
    return (
        <div className="top-gallery-wrapper xmb-10 xmb-lg-14">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="d-none d-lg-block">
                            <GalleryImage/>
                        </div>
                        <div className="d-block d-lg-none">
                            <GalleryImageResponsive/>
                        </div>
                    </div>
                    <div className="col-lg-6 product-information xpt-2 xpx-6">
                        <div className="title">
                            <h2 className="title-big xmb-3 xmb-lg-4">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB
                                RAM</h2>
                            <h3 className="title-small xmb-4 d-none d-lg-block">گوشی شیائومی می نوت ۹ پرو دوسیم کارت
                                ظرفیت ۶۴ گیگابایت - ۶
                                گیگ رم</h3>
                        </div>
                        <div className="score-product d-flex justify-content-start align-items-center">
                            <div className="star-rating" star-score={4}>
                                <IconName name="star" className="icon"/>
                                <IconName name="star" className="icon"/>
                                <IconName name="star" className="icon"/>
                                <IconName name="star" className="icon"/>
                                <IconName name="star" className="icon"/>
                            </div>
                            <div className="total-score-wrapper">
                                <span className="total-score persian-number">(112)</span>
                            </div>
                            <div className="proposal-product xmr-3">
                                <span className="share-button"><IconName name="share" className="icon xml-2"/></span>
                                <IconName name="favorite_border" className="icon d-inline-block d-lg-none xml-2"/>
                                <Link to="/comparisonPage"><IconName name="category"
                                                                     className="icon d-inline-block d-lg-none"/></Link>
                                <span className="text d-none d-lg-inline-block">بیش از ۹۹۹ نفر از خریداران این محصول را پیشنهاد داده‌اند</span>
                            </div>
                        </div>
                        <div
                            className="button-buy-responsive position-fixed d-flex d-lg-none xpy-2 xpx-5 xmb-6 justify-content-between align-items-center">
                            <div className="text-price-responsive">
                                <span className="total-price persian-number">5,480,000 ت</span>
                                <span className="discount persian-number">4,390,000 ت</span>
                            </div>

                                <div className="button-content" id="button-change-buy-page"><IconName name="cart" className="icon"/><span
                                    className="text">خرید</span></div>

                        </div>
                        <div className="info-product xmt-0 xmt-lg-6 xpy-3 xpx-4 xmb-6 xmb-lg-10">
                            <ul className="nav justify-content-between persian-number">
                                <li className="nav-item"><IconName name="aspect_ratio"
                                                                   className="icon"/><span>6.5 اینچ</span></li>
                                <li className="nav-item"><IconName name="camera_alt"
                                                                   className="icon"/><span>12 مگاپیکسل</span></li>
                                <li className="nav-item"><IconName name="ram_alt"
                                                                   className="icon"/><span>4 گیگ</span></li>
                                <li className="nav-item"><IconName name="battery_charging_full"
                                                                   className="icon"/><span>۵۰۰۰ میلی‌آمپر</span></li>
                            </ul>
                        </div>
                        <ul className="range-color-product nav xmb-10">
                            <li data-color-product="black"
                                className="range range-box-color nav-item active xmt-2 xmt-lg-0">
                                <span className="color color-black"></span>
                                مشکی
                            </li>
                            <li data-color-product="white" className="range range-box-color nav-item xmt-2 xmt-lg-0">
                                <span className="color color-white"></span>
                                سفید
                            </li>
                            <li data-color-product="red" className="range range-box-color nav-item xmt-2 xmt-lg-0">
                                <span className="color color-red"></span>
                                قرمز
                            </li>
                            <li data-color-product="blue" className="range range-box-color nav-item xmt-2 xmt-lg-0">
                                <span className="color color-blue"></span>
                                آبی
                            </li>
                        </ul>
                        <div className="seller-information xmb-10 d-none d-lg-block">
                            <ul className="list-unstyled">
                                <li className="position-relative xp-4">
                                    <IconName name="add_business" className="icon"/>
                                    <span className="seller-name">کامپیوتر زرد آذربایجان</span>
                                    <div className="function-seller position-relative"><span className="score">عملکرد ۳.۴ از ۵</span>
                                        <div className="popover-seller position-absolute">
                                            <div className="name-seller">
                                                <span className="name">کامپیوتر زرد آذربایجان</span>
                                                <span className="ok-seller">
                                                    <IconName name="check" className="icon"/>
                                        فروشنده برگزیده
                                                </span>
                                            </div>
                                            <div className="member-ship">
                                                <p
                                                    className="text"><span>عملکرد ۳.۴ از ۵</span>(عضویت از ۱ سال، ۶
                                                    ماه پیش) </p>
                                            </div>
                                            <div className="score-seller">
                                                <ul className="nav">
                                                    <li className="nav-item">
                                                        <span className="score persian-number good-score">100%</span>
                                                        <span className="text-score">تامین به موقع</span>
                                                    </li>
                                                    <li className="nav-item">
                                                        <span className="score persian-number bad-score">93.4%</span>
                                                        <span className="text-score">تعهد ارسال</span>
                                                    </li>
                                                    <li className="nav-item">
                                                        <span className="score persian-number good-score">95%</span>
                                                        <span className="text-score">بدون مرجوعی</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <span
                                        className="time-send-product position-absolute">ارسال کالا از ۱ روز کاری آینده</span>
                                    <div data-scroll="sellers-scroll" className="scroll-menu-smooth"><IconName name="chevron_left" className="icon more-icon position-absolute"/></div>
                                </li>
                                <li className="position-relative xp-4">
                                    <IconName name="verified_user" className="icon"/>
                                    <span className="register-product"> تضمین ثبت در شبکه رجیستری بدون هزینه اضافی (رجیستر شده)</span>
                                </li>
                            </ul>
                        </div>
                        <div className="seller-information-responsive d-block d-lg-none">
                            <ul className="list-unstyled">
                                <li className="position-relative xp-4 seller-responsive" id="open-sellers-responsive">

                                    <IconName name="add_business" className="icon"/>
                                    <span className="seller-name-responsive">کامپیوتر زرد آذربایجان</span>
                                    <div className="function-seller">
                                        <span className="selected"><IconName name="check"
                                                                             className="icon"/> برگزیده </span>
                                        <span className="function">   عملکرد ۳.۴ از۵</span>
                                    </div>
                                    <div className="more-icon-box position-absolute">
                                        <span>+۶</span>
                                        <IconName name="chevron_left" className="icon"/>
                                    </div>

                                </li>
                                <li className="position-relative xp-4">
                                    <IconName name="verified_user" className="icon"/>
                                    <span className="register-product">تضمین ثبت در شبکه رجیستری بدون هزینه …</span>
                                </li>
                            </ul>
                        </div>
                        <div className="buy-buttons d-none d-lg-flex">
                            <a id="button-buy-product" href="#" className="buy xml-4">
                                <IconName name="cart" className="icon"/>
                                <span className="text-buy">خرید ۵،۴۸۹،۰۰۰ ت</span>
                            </a>
                            <a href="#" className="add-favorite xml-4">
                                <IconName name="favorite_border" className="icon"/>
                                <span className="text-favorite">افزودن به علاقه‌مندی</span>
                            </a>
                            <Link to="/comparisonPage" className="comparison">
                                <IconName name="category" className="icon"/>
                                <span className="text-category">مقایسه</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            {/*share link modal*/}
            <div className="share-link-modal share-wrapper-modal">
                <div className="title-share">
                    <span>اشتراک گذاری</span>
                    <span id="button-close-share-modal" className="position-absolute more-icon"><IconName
                        name="expand_close" className="icon"/></span>
                </div>
                <div className="social-media-share">
                    <ul className="nav">
                        <li className="nav-item">
                            <a href="#" className="nav-link social-media telegram"><IconName name="telegram"
                                                                                             className="icon"/></a>
                        </li>
                        <li className="nav-item xmr-4">
                            <a href="#" className="nav-link social-media twitter"><IconName name="twitter"
                                                                                            className="icon"/></a>
                        </li>
                        <li className="nav-item xmr-4">
                            <a href="#" className="nav-link social-media whatsapp"><IconName name="whatsapp"
                                                                                             className="icon"/></a>
                        </li>
                        <li className="nav-item xmr-4">
                            <a href="#" className="nav-link copy"><IconName name="content_copy" className="icon"/>
                                <span>کپی
                                لینک</span></a>
                        </li>
                    </ul>
                </div>
            </div>
            {/*end share link modal*/}
        </div>
    );
};

export default TopGalleryProduct;
